/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AsyncSelect from "react-select/async";
import Select from "react-select";

//calendar --------------------------------------------
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
// -----------------------------------------------

import * as url from "helper/UrlHelper";
import { getData, putData, postData } from "utils/Gateway";
import { reactSelectStyle } from "Config/Config";
import { assetImages } from "constants";
import { getDateFormatInSpanish } from "helper/Common/CommonHelper";
import MeetingReasonOptions from "data/Prod/MeetingReason.json";

const SaveAppointmentPopup = ({
  afterActionClose = () => {},
  patientObj = null,
}) => {
  const localizer = momentLocalizer(moment);
  const token = localStorage.getItem("token");

  // set color to event
  const eventStyleGetter = (selectedId) => (event) => {
    const backgroundColor =
      event.id === selectedId
        ? "#FFA500"
        : event.availability
        ? "#05843e"
        : "#DF3429"; // orange for selected, green for available, red for unavailable
    return { style: { backgroundColor } };
  };

  const [currentStep, setCurrentStep] = useState(1);
  const [patient, setPatient] = useState(null);
  const [doctor, setDoctor] = useState(null);
  const [doctorCalendarDates, setDoctorCalendarDates] = useState([]);
  const [selectedDoctorEventId, setSelectedDoctorEventId] = useState(null);

  const [appointmentDate, setAppointmentDate] = useState("");
  const [appointmentStartTime, setAppointmentStartTime] = useState("");
  const [appointmentEndTime, setAppointmentEndTime] = useState("");
  const [companyName, setCompanyName] = useState("");

  const [meetingReasonValue, setMeetingReasonValue] = useState(null);
  const [meetingReasonString, setMeetingReasonString] = useState("");
  const [commentMessage, setCommentMessage] = useState("");
  const [additionalMeetingDetails, setAdditionalMeetingDetails] = useState("");

  const [isSaving, setIsSaving] = useState(false);
  const [isDoctorCalendarLoading, setIsDoctorCalendarLoading] = useState(false);

  // Async load options for patients (reusing getMemberOptions)
  const loadPatientOptions = async (inputValue) => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_LIST_BY_USER +
        `?token=${token}&userstringinput=${inputValue}&modulefrom=backend&filterroleslug=PATIENT`;

      // console.log("requestUrl in patient", requestUrl);

      const reponse = await getData(requestUrl);
      // console.log("response in patient", reponse);
      return reponse.data;
    } catch (error) {
      return [];
    }
  };

  // Async load options for doctors (reusing getMemberOptions)
  const loadDoctorOptions = async (inputValue) => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_LIST_BY_USER +
        `?token=${token}&userstringinput=${inputValue}&modulefrom=backend&filterroleslug=DOCTOR`;

      const reponse = await getData(requestUrl);
      return reponse.data;
    } catch (error) {
      return [];
    }
  };

  //function for load doctor calendar dates
  const loadDoctorCalendarDates = async (doctorId) => {
    setIsDoctorCalendarLoading(true);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_AGENDA +
        `?token=${token}&useraccount=${doctorId}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setDoctorCalendarEventData(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
    setIsDoctorCalendarLoading(false);
  };

  // arrange the doctor event data for big calendar
  const setDoctorCalendarEventData = (agendaRecords = []) => {
    const events = agendaRecords
      .filter((item) => item.availability === true)
      .map(
        ({
          _id,
          description,
          date,
          starttime,
          endtime,
          availability,
          companyname,
        }) => {
          return {
            id: _id,
            title: description,
            start: new Date(`${date}T${starttime}:00`),
            end: new Date(`${date}T${endtime}:00`),
            availability,
            companyname,
          };
        }
      );

    setDoctorCalendarDates(events);
  };

  //function for select doctor event
  const onSelectDoctorEvent = (event) => {
    if (selectedDoctorEventId === event.id) {
      setSelectedDoctorEventId(null);
      setAppointmentDate("");
      setAppointmentStartTime("");
      setAppointmentEndTime("");
      setCompanyName("");
    } else {
      setSelectedDoctorEventId(event.id);
      setAppointmentDate(event.start.toISOString().split("T")[0]);
      setAppointmentStartTime(moment(event.start).format("HH:mm"));
      setAppointmentEndTime(moment(event.end).format("HH:mm"));
      setCompanyName(event.companyname);
    }
  };

  //function for save
  const saveAppointmentHandler = async () => {
    try {
      setIsSaving(true);

      const apiData = {
        senderemail: patient ? patient?.email : "",
        reciever: doctor ? doctor?.value : null,
        meetingdate: appointmentDate,
        starttime: appointmentStartTime,
        endtime: appointmentEndTime,
        message: commentMessage,
        meetingdetails: additionalMeetingDetails,
        meetingreason: meetingReasonString,
      };

      // console.log("apiData in save appointment", apiData); // Added this line to check the data being sent

      let requestUrl =
        url.API_BASE_URL + url.API_SEND_REQUEST_MEETING_AGENDA_BY_GUEST;

      const response = await postData(requestUrl, apiData);

      console.log("response in save appointment", response); // Added this line to check the response from the server

      setIsSaving(false);

      if (response.status) {
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#saveAppointmentOffCanvas")
        ).hide();
        resetHandler();
        afterActionClose();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for reset all states
  const resetHandler = () => {
    setCurrentStep(1);
    setPatient(patientObj);
    setDoctor(null);
    setDoctorCalendarDates([]);
    setSelectedDoctorEventId(null);
    setAppointmentDate("");
    setAppointmentStartTime("");
    setAppointmentEndTime("");
    setMeetingReasonValue(null);
    setCommentMessage("");
    setAdditionalMeetingDetails("");
  };

  useEffect(() => {
    if (patientObj) {
      setPatient(patientObj);
    }
  }, [patientObj]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveAppointmentOffCanvas"
      aria-labelledby="saveAppointmentOffCanvasLabel"
    >
      {/* Header */}
      <div className="offcanvas-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary icon-md">
              calendar_month
            </span>
          </div>
          <div>
            <p
              className="offcanvas-title text-white mb-0"
              id="saveAppointmentOffCanvasLabel"
            >
              <span className="d-block pe-3 me-3">
                <span className="fw-bold">{currentStep}</span> of 3
              </span>
              {currentStep === 1
                ? "Select Patient for Appointment"
                : currentStep === 2
                ? "Select Doctor for Appointment"
                : "Schedule Appointment"}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div
        className="progress"
        role="progressbar"
        aria-label="Example 1px high"
        aria-valuenow={
          currentStep === 1 ? "33.333" : currentStep === 2 ? "66.666" : "100"
        }
        aria-valuemin="0"
        aria-valuemax="100"
        style={{ height: "2px" }}
      >
        <div
          className="progress-bar"
          style={{
            width:
              currentStep === 1
                ? "33.333%"
                : currentStep === 2
                ? "66.666%"
                : "100%",
          }}
        ></div>
      </div>

      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-white">
          {/* Step 1: Select Patient */}
          <div className={currentStep === 1 ? "d-block" : "d-none"} id="step_1">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="form-group mb-4">
                <label className="d-block fw-semibold mb-2">
                  Select Patient <span className="text-danger fw-bold">*</span>
                </label>
                <AsyncSelect
                  isClearable
                  name="patientName"
                  loadOptions={loadPatientOptions}
                  defaultOptions={false}
                  cacheOptions={false}
                  placeholder="Type patient name"
                  styles={reactSelectStyle("3px", "6px", true, false)}
                  value={patient}
                  onChange={(option) => {
                    setPatient(option);
                  }}
                />
              </div>
            </form>

            {patient ? (
              <div className="patient-details p-3 border border-gray-300 rounded-8 shadow-sm">
                {/* Patient details */}
                <div className="d-flex gap-3">
                  <div
                    className="avatar rounded-circle overflow-hidden"
                    style={{
                      width: "60px",
                      height: "60px",
                    }}
                  >
                    <img
                      className="w-100 h-100 object-fit-cover"
                      src={
                        patient?.image !== ""
                          ? url.SERVER_URL + patient?.image
                          : assetImages.defaultUser
                      }
                      alt="patient"
                    />
                  </div>
                  <div>
                    <p className="mb-0">{patient?.label}</p>
                    <p className="font-sm text-gray mb-1">
                      Patient Email: {patient?.email}
                    </p>
                  </div>
                </div>
                {/* Calendar details for patient */}
                <div className="contact-info pt-3 border-top border-gray-100 mt-3">
                  <p className="fw-semibold mb-2">
                    Information for {patient?.label}
                  </p>
                  <p className="font-sm text-gray mb-1">
                    Phone: {patient?.phone}
                  </p>
                  <p className="font-sm text-gray mb-1">
                    City: {patient?.city}
                  </p>
                  <p className="font-sm text-gray mb-1">
                    State: {patient?.state}
                  </p>
                  <p className="font-sm text-gray mb-1">
                    Country: {patient?.country}
                  </p>
                </div>
              </div>
            ) : null}

            <div
              className={
                patient
                  ? "group_btnOuter d-flex justify-content-end mt-3"
                  : "d-none"
              }
            >
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={() => setCurrentStep(2)}
              >
                Next Step
                <span className="material-symbols-outlined">chevron_right</span>
              </button>
            </div>
          </div>

          {/* Step 2: Select Doctor */}
          <div className={currentStep === 2 ? "d-block" : "d-none"} id="step_2">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="form-group mb-4">
                <label className="d-block fw-semibold mb-2">
                  Select Doctor <span className="text-danger fw-bold">*</span>
                </label>
                <AsyncSelect
                  isClearable
                  name="doctorName"
                  loadOptions={loadDoctorOptions}
                  defaultOptions={false}
                  cacheOptions={false}
                  placeholder="Type doctor name"
                  styles={reactSelectStyle("3px", "6px", true, false)}
                  value={doctor}
                  onChange={(option) => {
                    setDoctor(option);
                    loadDoctorCalendarDates(option?.value);
                  }}
                />
              </div>
            </form>

            {doctor ? (
              <div className="doctor-details">
                {/* Doctor details */}
                <div className="d-flex gap-3 border border-gray-300 p-3 rounded-8">
                  <div
                    className="avatar rounded-circle overflow-hidden"
                    style={{
                      width: "60px",
                      height: "60px",
                    }}
                  >
                    <img
                      className="w-100 h-100 object-fit-cover"
                      src={
                        doctor?.image !== ""
                          ? url.SERVER_URL + doctor?.image
                          : assetImages.defaultUser
                      }
                      alt="doctor"
                    />
                  </div>
                  <div>
                    <p className="mb-0">{doctor?.label}</p>
                    <p className="font-sm text-gray mb-1">
                      Doctor Email: {doctor?.email}
                    </p>
                  </div>
                </div>
                {/* Calendar details for doctor */}
                <div className="contact-info pt-3 border-top border-gray-100 mt-3">
                  <p className="fw-semibold mb-2">
                    Available Slots Information for {doctor?.label}
                  </p>
                  <div style={{ height: 500, position: "relative" }}>
                    {isDoctorCalendarLoading ? (
                      <div
                        style={{
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                          background: "rgba(255,255,255,0.8)",
                          zIndex: 2,
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                        }}
                      >
                        <div
                          className="spinner-border text-primary"
                          style={{ width: "3rem", height: "3rem" }}
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <div className="mt-3 fw-semibold text-primary">
                          Loading available slots...
                        </div>
                      </div>
                    ) : (
                      <Calendar
                        localizer={localizer}
                        events={doctorCalendarDates}
                        startAccessor="start"
                        endAccessor="end"
                        onSelectEvent={onSelectDoctorEvent}
                        selectable
                        style={{ flex: 1 }}
                        eventPropGetter={eventStyleGetter(
                          selectedDoctorEventId
                        )}
                      />
                    )}
                  </div>
                  {appointmentDate && (
                    <div className="mt-3 p-3 bg-light border border-gray-300 rounded-8">
                      <p className="mb-1 fw-semibold">
                        Selected Date, Time & Clinic:
                      </p>
                      <p className="mb-0">
                        Date:{" "}
                        {appointmentDate !== ""
                          ? getDateFormatInSpanish(appointmentDate)
                          : ""}
                      </p>
                      <p className="mb-0">
                        Time: {appointmentStartTime} - {appointmentEndTime}
                      </p>
                      <p className="mb-0">Clinic : {companyName}</p>
                    </div>
                  )}
                </div>
              </div>
            ) : null}

            <div className="group_btnOuter d-flex justify-content-between mt-3">
              <button
                type="button"
                className="btn btn-outline-primary d-flex align-items-center gap-2"
                onClick={() => setCurrentStep(1)}
              >
                <span className="material-symbols-outlined">chevron_left</span>
                <span>Previous Step</span>
              </button>
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={() => setCurrentStep(3)}
                disabled={!doctor}
              >
                Next Step
                <span className="material-symbols-outlined">chevron_right</span>
              </button>
            </div>
          </div>

          {/* Step 3: Schedule Appointment */}
          <div className={currentStep === 3 ? "d-block" : "d-none"} id="step_3">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="form-group mb-4">
                <label className="d-block fw-semibold mb-2">
                  Reason for Meeting{" "}
                  <span className="text-danger fw-bold">*</span>
                </label>
                <Select
                  isClearable
                  name="reasonForMeeting"
                  options={MeetingReasonOptions}
                  placeholder="Select reason"
                  styles={reactSelectStyle("3px", "6px", true, false)}
                  value={meetingReasonValue}
                  onChange={(val) => {
                    setMeetingReasonValue(val);
                    setMeetingReasonString(val?.value || "");
                  }}
                />
              </div>
              <div className="form-group mb-4">
                <label className="d-block fw-semibold mb-2">
                  Comments <span className="text-danger fw-bold">*</span>
                </label>
                <textarea
                  name="comments"
                  id="comments"
                  rows="5"
                  placeholder="Enter Comments"
                  className="form-control px-4 py-3 lh-1 rounded-10 border border-gray-300 shadow-none"
                  value={commentMessage}
                  onChange={(e) => setCommentMessage(e.target.value)}
                ></textarea>
              </div>
              <div className="form-group mb-4">
                <label className="d-block fw-semibold mb-2">
                  Additional Meeting Details
                </label>
                <textarea
                  name="additionalMeetingDetails"
                  id="additionalMeetingDetails"
                  rows="5"
                  placeholder="Enter additional details (optional)"
                  className="form-control px-4 py-3 lh-1 rounded-10 border border-gray-300 shadow-none"
                  value={additionalMeetingDetails}
                  onChange={(e) => setAdditionalMeetingDetails(e.target.value)}
                ></textarea>
              </div>
            </form>
            <div className="group_btnOuter d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-outline-primary fw-semibold rounded-10 m-0 d-flex align-items-center gap-2"
                onClick={() => setCurrentStep(2)}
              >
                <span className="material-symbols-outlined">chevron_left</span>
                <span>Previous Step</span>
              </button>
              {meetingReasonValue && commentMessage.trim() && (
                <button
                  type="button"
                  className="btn btn-primary d-flex align-items-center gap-2"
                  onClick={saveAppointmentHandler}
                  disabled={isSaving}
                  style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                >
                  {isSaving ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Saving...
                    </>
                  ) : (
                    <>
                      <span className="material-symbols-outlined me-1">
                        save
                      </span>
                      Save Appointment
                    </>
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveAppointmentPopup;
